import { ExclamationCircleFilled } from '@ant-design/icons';
import { Popover } from 'antd';
import React from 'react';
import { GetIcon } from 'datastake-daf/dist/components';
import { useTranslation } from 'react-i18next';
import { config } from './helper';
import Widget from '../../widget';
import Style, { EmptyState, PopOver } from './style';

export default function DueDilligenceOverview({
  data,
  isOwnData = true,
}) {
  const { t } = useTranslation();
  return (data) ? (
    <Style>
      <Widget
        title={t('Due Diligence Systems')}
      >
        <div className="items dds-items">
          {Object.entries(config).map(([k, v]) => (
            <div key={`dds-sections-${k}`} className="item">
              <div className="item-cont icon">
                <div className="cont">
                  <GetIcon icon={v.icon} />
                </div>
              </div>
              <div className="item-cont item-header">
                <div className="cont">
                  <h2>{t(v.label)}</h2>
                </div>
              </div>
              <div className="item-cont value" style={{ flexDirection: 'row' }}>
                <div className="cont">
                  <h2>
                    {data[k] || 0}%
                  </h2>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Widget>
    </Style>
  ) : (
    <section>
      <EmptyState>
        <label>
          <strong>
            {t('Risk Readiness Summary')}:
          </strong>
          {' '}
          {t('Unavailable')}
        </label>
        <Popover
          placement="right"
          content={<PopOver>
            <h4 className="title">{t('What does this mean?')}</h4>
            <p>{t('Supply chain due diligence systems implemented by the organisation have not been assessed')}</p>
          </PopOver>}
        >
          <ExclamationCircleFilled />
        </Popover>
      </EmptyState>
    </section>
  );
}
